import React from 'react'
import { AppLoader, LoaderType } from 'components/AppLoader'

interface ModelTrainingLoaderProps {
  isLoading: boolean
}

export const ModelTrainingLoader: React.FC<ModelTrainingLoaderProps> = ({
  isLoading,
}) => {
  if (!isLoading) return null

  return (
    <div className="model-training-loader">
      <div className="loader-spinner">
        <AppLoader loaderType={LoaderType.lower} />
      </div>
      <span className="loader-text">Обучение модели...</span>
    </div>
  )
}
